/**
 * Generato automaticamente.
 * framework-cmp-domande
 */

export type GetFrontNotificheSortField =
  (typeof GetFrontNotificheSortField)[keyof typeof GetFrontNotificheSortField];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetFrontNotificheSortField = {
  DATA_NOTIFICA: 'DATA_NOTIFICA',
  DATA_PRESA_VISIONE: 'DATA_PRESA_VISIONE',
  TIPO: 'TIPO',
  PRIORITA: 'PRIORITA',
} as const;
